import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { TagsModule } from '@app/tags/tags.module';
import { AccomplishmentModalComponent } from './user-outcome/accomplishment-modal/accomplishment-modal.component';

import { GlobalAddResultsComponent } from './global-add-results/global-add-results.component';
import { PostFormComponent } from './user-input/post-form/post-form.component';
import { TaskModalComponent } from './user-input/task-modal/task-modal.component';

import { MarkdownModule } from '@app/markdown/markdown.module';
import { UserOutcomeImageUploadAdapter } from './services/adapters/user-outcome-image-upload.adapter';
import { BadgeUploadAdapter } from './user-outcome/badge-modal/badge-upload.adapter';
import { UploaderModule } from '@app/uploader/uploader.module';
import { BadgeModalComponent } from './user-outcome/badge-modal/badge-modal.component';
import { AwardModalComponent } from './user-outcome/award-modal/award-modal.component';
import { CertificateModalComponent } from './user-outcome/certificate-modal/certificate-modal.component';
import { DegreeModalComponent } from './user-outcome/degree-modal/degree-modal.component';
import { CourseFormalFormComponent } from './user-input/course-form/course-formal-form/course-formal-form.component';
import { CourseInformalFormComponent } from './user-input/course-form/course-informal-form/course-informal-form.component';
import { CourseModalComponent } from './user-input/course-form/course-modal.component';
import { CourseFormDomainService } from './user-input/course-form/course-form-domain.service';
import { GroupsSharedModule } from '@app/groups/groups-shared.module';
import { FormFieldsModule } from '@app/form-fields/form-fields.module';
import { OrgsSharedModule } from '@app/orgs/orgs-shared.module';
import { InputsModule } from '@app/inputs/inputs.module';
import { ModalContainerComponent } from './modal-container/modal-container.component';
import { UserInputModule } from './user-input/user-input.module';
import { CertificateUploadAdapter } from './user-outcome/certificate-modal/certificate-upload.adapter';
import { ImageUrlService } from './user-input/services/image-url.service';
import { ExperienceModalComponent } from './user-input/experience-modal/experience-modal.component';
import { AuthorSharedModule } from '@app/author/author-shared.module';
import { ArticleCatalogComponent } from './user-input-v2/inputs/article/components/catalog/article-catalog.component';
import { ArticlePathwaysPlansComponent } from './user-input-v2/inputs/article/components/pathways-and-plans/article-pathways-plans.component';
import { AdvancedSettingsComponent } from './user-input-v2/inputs/shared/components/advanced-settings-component/advanced-settings.component';
import { DurationComponent } from './user-input-v2/inputs/shared/components/duration/duration.component';
import { UserModule } from '@app/user/user.module';
import { ReactiveFormsLabelComponent } from './user-input-v2/inputs/shared/components/reactive-forms-label/reactive-forms-label.component';
import { AddToCatalogComponent } from './user-input-v2/inputs/shared/components/add-to-catalog/add-to-catalog.component';
import { InputsSharedModule } from '@app/inputs/inputs-shared.module';

/** A module for user content related items such as User Inputs and Achievements (a.k.a Outcomes) */
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    TagsModule,
    MarkdownModule,
    UploaderModule,
    GroupsSharedModule,
    FormFieldsModule,
    OrgsSharedModule,
    InputsSharedModule,
    UserInputModule,
    AuthorSharedModule,
    UserModule,
  ],
  declarations: [
    ExperienceModalComponent,
    AwardModalComponent,
    BadgeModalComponent,
    CertificateModalComponent,
    AccomplishmentModalComponent,
    DegreeModalComponent,
    GlobalAddResultsComponent,
    PostFormComponent,
    TaskModalComponent,
    CourseModalComponent,
    CourseFormalFormComponent,
    CourseInformalFormComponent,
    ModalContainerComponent,
    ArticleCatalogComponent,
    ArticlePathwaysPlansComponent,
    AdvancedSettingsComponent,
    DurationComponent,
    ReactiveFormsLabelComponent,
    AddToCatalogComponent,
  ],
  exports: [
    ExperienceModalComponent,
    AwardModalComponent,
    BadgeModalComponent,
    CertificateModalComponent,
    DegreeModalComponent,
    GlobalAddResultsComponent,
    CourseModalComponent,
    CourseFormalFormComponent,
    CourseInformalFormComponent,
    ModalContainerComponent,
    ArticleCatalogComponent,
    AdvancedSettingsComponent,
    DurationComponent,
    ReactiveFormsLabelComponent,
  ],
  providers: [
    UserOutcomeImageUploadAdapter,
    BadgeUploadAdapter,
    CertificateUploadAdapter,
    CourseFormDomainService,
    ImageUrlService,
  ],
})
export class UserContentModule {}
